import { lookupEntities } from "@/api/lookup";
import { getEntityOverview } from "@/api/overview";
import Overview from "@/models/Overview.model";
import { types } from "./mutations";

export default {
  /**
   * Fetches the lookup data for specified entity
   */
  fetchLookupData: async (
    _,
    { entity_id, page_id, columns, filters, sort_by, sort_order }
  ) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await lookupEntities({
          entity_id,
          page_id,
          columns,
          filters,
          sort_by,
          sort_order,
        });
        if (!(response.status === 200 && response.data)) {
          throw new Error("Invalid response data");
        }

        return resolve(response.data);
      } catch (error) {
        console.error(error);
        return reject(error);
      }
    });
  },

  /**
   * Fetches detailed overview of a particular entity item
   */
  fetchEntityOverview: async (
    _,
    { entity_id, entity_item_id, columns, page_id, filters }
  ) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await getEntityOverview({
          entity_id,
          entity_item_id,
          columns,
          page_id,
          filters,
        });
        if (!(response.status === 200 && response.data.data)) {
          throw new Error("Invalid response");
        }

        return resolve(new Overview(response.data.data));
      } catch (error) {
        console.error(error);
        return reject(error);
      }
    });
  },

  /**
   * Resets the module state
   * @param {} param0
   */
  reset: async ({ commit, dispatch }) => {
    dispatch("Map/reset", {}, { root: true });
    commit(types.reset);
  },
};
